import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-[800px] mx-auto px-4 md:px-8 py-24 md:py-36 text-center">
      <Seo title="Page not found" noindex />
      <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">404</div>
      <h1 className="font-serif text-4xl md:text-6xl mb-6">This page doesn't exist.</h1>
      <p className="text-muted-foreground mb-10">The link may be outdated, or the page may have moved.</p>
      <div className="flex items-center justify-center gap-4 flex-wrap">
        <Link to="/" data-testid="notfound-home" className="border border-primary text-primary px-6 py-3 text-xs uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-colors duration-300">
          Back to home
        </Link>
        <Link to="/categories" className="border hairline px-6 py-3 text-xs uppercase tracking-widest hover:border-primary/60 transition-colors duration-300">
          Browse categories
        </Link>
      </div>
    </div>
  );
}
